import React, { createContext, useContext, useEffect, useState } from 'react';

const PreLoaderContext = createContext();

export const usePreLoaderContext = () => {
  return useContext(PreLoaderContext);
};

export const PreLoaderProvider = ({ children }) => {
  const [pathIndex, setPathIndex] = useState(false);
  const [preLoaderVisible, setPreLoaderVisible] = useState(false);

  const colors = ['#ff5b05', '#30363f'];

  useEffect(() => {
    let interval;
  
    if (preLoaderVisible) {
      interval = setInterval(() => {
        setPathIndex((prevIndex) => !prevIndex);
      }, 1000);
    }
  
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [preLoaderVisible, setPathIndex]);


  const value = {
    pathIndex,
    colors,
    preLoaderVisible,
    setPreLoaderVisible,
  };

  return (
    <PreLoaderContext.Provider value={value}>
      {children}
    </PreLoaderContext.Provider>
  );
};